import { TR, TDT } from "../../components";
import { FaShareAlt } from "react-icons/fa";
import { FiEdit2 } from "react-icons/fi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import TableContext from "../Provider/TableContext";

function TableRow(props) {
  const { doc } = props;
  const navigate = useNavigate();
  const { setShowDeleteModal, setSystemId } = useContext(TableContext);

  // Function to trigger delete modal
  function showDelete() {
    setSystemId(doc?.id);
    setShowDeleteModal(true);
  }

  return (
    <TR>
      <TDT name="DEVICE ID" txt={doc?.device_id || "--"} />
      <TDT name="SIM CARD NO" txt={doc?.sim_card_no || "--"} />
      <TDT name="IMEI" txt={doc?.imei || "--"} />
      <TDT name="MAC Address" txt={doc?.mac_address || "--"} />
      <TDT name="DEVICE TYPE ID" txt={doc?.device_type_id || "--"} />
      {/* <TDT name="Created At" txt={doc?.created_at || "--"} /> */}
      {/* <TDT name="Updated At" txt={doc?.updated_at || "--"} /> */}
      {/* <TDT name="FGUID" txt={doc?.fguid || "--"} /> */}
      {/* <TDT name="Device Deactivation" txt={doc?.device_deactivation || "--"} /> */}
      {/* <TDT name="Vehicle Devices" txt={doc?.vehicle_devices || "--"} /> */}

      <TDT
        name="ACTION"
        txt={
          <div className="flex gap-4">
            {/* Navigation to Edit page
            <div className="cursor-pointer">
              <p
                className="text-center flex gap-2"
                onClick={() => navigate(`edit/${doc?.id}`)}
              >
                <FiEdit2 className="text-2xl text-center" />
              </p>
            </div> */}
            {/* Trigger the delete action */}
            <div onClick={showDelete} className="cursor-pointer">
              <p className="text-center flex gap-2">
                <RiDeleteBin5Line className="text-red-500 text-2xl text-center cursor-pointer" />
              </p>
            </div>
          </div>
        }
      />
    </TR>
  );
}

export default TableRow;
